import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectNewProduct = (state: StoreSchema) =>
    state.newProductState.newProduct
